// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"843eaebd","787":"59d44cd3"}[chunkId] + ".chunk.js";
};